export const getValue = (source, defaultValue) => {
  if (source === null || source === void 0) {
    return defaultValue
  }
  return source
}